import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Container,
  LoadingBounce,
  Panel,
} from '@michelin/acid-components';
import { ChangeLogEntities } from 'Types';
import useCommercialLocation from 'hooks/useCommercialLocation';
import useCustomer from 'hooks/useCustomer';
import useCommercialProducts from 'hooks/useCommercialProducts';
import useUtils from 'hooks/useUtils';
import { PlainMessage } from 'components/PlainMessage';
import LastModified from 'components/ChangeLog/LastModified';
import { PageTitle } from 'Utils/CanvasPageTitle';
import CommercialProductsPanel from './CommercialProductsPanel';

interface Props {
  action: 'edit' | 'view' | 'add',
}

export function CommercialProducts(props: Props) {
  const { t } = useTranslation();
  const { stNumber } = useParams<{ stNumber: string }>();
  const commercialQuery = useCommercialLocation(stNumber);
  const customerQuery = useCustomer(stNumber);
  const commercialProds = useCommercialProducts(stNumber);
  const { subTitle } = useUtils();

  if (commercialQuery.isLoading || customerQuery.isLoading || commercialProds.isLoading) return <LoadingBounce style={{ height: '70vh' }} />;
  if (!commercialProds.data) return <PlainMessage title={t('Error loading commercial products')} messages={t('Please try again later')} />;

  return (
    <>
      <PageTitle
        title="Commercial Truck Products"
        subtitle={subTitle}
        rightItems={(<LastModified entity={ChangeLogEntities.products} />)}
      />
      <Container>
        <Panel>
          <CommercialProductsPanel
            products={commercialProds.data}
            action={props.action}
          />
        </Panel>
      </Container>

    </>
  );
}
